import {
    /** FETCH SUGGESTIONS  */
    FETCH_SUGGESTIONS_FULFILLED,
    FETCH_SUGGESTIONS_REJECTED,
    FETCH_SUGGESTIONS_PENDING,
    RESET_SUGGESTIONS
} from "../actions/suggestions";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SUGGESTIONS_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_SUGGESTIONS_FULFILLED:
            return {
                ...state,
                suggestions: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_SUGGESTIONS_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_SUGGESTIONS:
            return {
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};